import type { StandardKpi } from '../types';

export const useStandardKpi = () => {
  // Store
  const { standardResponse, areaId } = storeToRefs(standardStore());

  // Composables
  const { t } = useI18n();
  const { formatNumberToIsoNumber } = useNumbers();
  const { areaProductionUnit, areaFabricationOrderUnit } = coreAreaHelper();

  // =================================== KPI ===================================
  const getKpis = computed((): StandardKpi | null => {
    const data = standardResponse.value;
    if (!data) return null;
    const type = data.type;

    if (type === 'production' || type === 'fabrication_order') {
      const unit = type === 'production' ? areaProductionUnit(areaId.value) : areaFabricationOrderUnit(areaId.value);

      return {
        titleValue: `${formatNumberToIsoNumber(data.average_epi.quantity, 2)}`,
        titleUnit: 'kWh / ' + unit,
        subtitle: t('standard.average_epi'),
        versus: data.average_deviation_percentage
          ? {
              value: formatNumberToIsoNumber(data.average_deviation_percentage ? Math.abs(data.average_deviation_percentage) : 0),
              sign: Math.sign(data.average_deviation_percentage) === 1 ? '+' : '-',
            }
          : undefined,
        children: [
          {
            icon: 'Gauge',
            kpi: formatNumberToIsoNumber(data.total_consumption.quantity) + ' kWh',
            label: t('standard.total_consumption'),
          },
          {
            icon: 'PlugZap',
            kpi: formatNumberToIsoNumber(data.average_power) + ' kW',
            label: t('standard.average_power'),
          },
          {
            icon: 'ShoppingBag',
            kpi: `${formatNumberToIsoNumber(Number(data.total_production))} ${unit}`,
            label: t('standard.total_quantity'),
          },
        ],
      };
    } else if (type === 'weekly') {
      return {
        titleValue: `${formatNumberToIsoNumber(data.average_power)}`,
        titleUnit: 'kW',
        subtitle: t('standard.average_power'),
        versus: data.average_deviation_percentage
          ? {
              value: formatNumberToIsoNumber(data.average_deviation_percentage ? Math.abs(data.average_deviation_percentage) : 0),
              sign: Math.sign(data.average_deviation_percentage) === 1 ? '+' : '-',
            }
          : undefined,
        children: [
          {
            icon: 'Gauge',
            kpi: formatNumberToIsoNumber(data.total_consumption.quantity) + ' kWh',
            label: t('standard.total_consumption'),
          },
          {
            icon: 'Euro',
            kpi: formatNumberToIsoNumber(Number(data.total_consumption.cost)) + ' €',
            label: t('standard.total_cost'),
          },
        ],
      };
    }
    return null;
  });

  return { getKpis };
};
